import { POST, postFile, GET } from "../../index";

export const getRegulations = (param) => POST("/v1/regulations/getRegulations", param);
export const insertRegulations = (param) => POST("/v1/regulations/insertRegulations", param);
export const deleteRegulations = (param) => POST("/v1/regulations/deleteRegulations", param);